export default "__VITE_ASSET__5v$oCiyZ__"